/* eslint-disable class-methods-use-this */
import Router from '../utils/router';
import IntroView from './views/intro';
import EligibilityView from './views/eligibility';
import PrivacyView from './views/privacy';
import FormView from './views/form';
import ResultView from './views/result';
import HelpView from './views/help';
import Form from '../form_builder_2/form';
import FormPopulator from './helpers/form-populator';
import { scrollToElement } from '../utils/dom';
import HashManager from '../utils/hash-manager';
import AnalyticsHelper from '../utils/analytics-helper';

export default class FinanceApplication {
    constructor(el) {
        this.el = el;

        this.util = window.HONDA.MyAccount2;
        this.router = new Router();

        this.callbacks = {
            onSubmit: this.onSubmit.bind(this),
            onSuccess: this.onSuccess.bind(this),
            onError: this.onError.bind(this),
            onUpdate: this.onUpdate.bind(this),
            onInvalid: this.onInvalid.bind(this),
        };

        this.form = new Form(this.el, this.callbacks);
        this.views = {
            intro: new IntroView(this, this.router),
            privacy: new PrivacyView(this, this.router),
            eligibility: new EligibilityView(this, this.router),
            form: new FormView(this, this.router),
            result: new ResultView(this, this.router),
            help: new HelpView(this, this.router),
        };
        this.formEl = this.form.form;
        this.cancelPath = this.el.dataset.cancelPath;

        this.hashManager = new HashManager(this);
        this.formPopulator = new FormPopulator(this);
        this.preventSubmitInput = this.el.querySelector('input[name="preventSubmitToUnderwriting"]');

        this.spaContainer = this.el.querySelector('.spa-container');
        this.invalidOrderError = this.el.querySelector('.error-invalid-order');
        this.applicationSubmittedError = this.el.querySelector('.error-application-submitted');
        this.loader = this.el.querySelector('.finance-application-loader');
        this.AnalyticsHelper = AnalyticsHelper;

        this.init();
    }

    init() {
        if (!this.util.isLoggedIn()) {
            this.util.showModal({ guest: false, close: true });
        }

        this.util.addEventListener('expires', () => this.util.showModal({ guest: false, close: true }));
        this.util.addEventListener('close', () => this.redirect(this.cancelPath));
        this.util.addEventListener('login', () => this.onLogin());
    }

    async onLogin() {
        this.showLoader();
        this.orders = await window.HONDA.MyAccount2.client.getOrders() ?? [];
        this.orderId = this.hashManager.get('orderId');
        this.order = this.orders.find((o) => o.orderId === this.orderId);
        this.hasFinance = !!this.order?.financeSummary?.campaignCode;

        if (!this.orderId || !this.order || !this.hasFinance) {
            this.spaContainer?.classList.add('hide');
            this.invalidOrderError?.classList.remove('hide');
            this.hideLoader();
            return;
        }

        if (this.order.financeStatus && this.order.financeStatus !== 'Working') {
            this.spaContainer?.classList.add('hide');
            this.applicationSubmittedError?.classList.remove('hide');
            this.hideLoader();
            return;
        }

        if (!this.order.financeApplicationStartedAt) {
            window.HONDA.MyAccount2.client.startFinanceApplication(this.order?.customerInfo?.email, this.order?.orderId, this.order?.financeProposalNumber);
        }

        this.setup();
        this.views.eligibility.setupFinanceSuitability(this.order);
        await this.formPopulator.populateForm(this.order);
        this.hideLoader();
    }

    setup() {
        this.router
            .add('intro', () => {
                this.switch('intro');
            })
            .add('privacy', () => {
                this.switch('privacy');
            })
            .add('eligibility', () => {
                this.switch('eligibility');
            })
            .add('form', () => {
                this.switchForm();
            })
            .add('result', () => {
                this.switch('result');
            })
            .add('help', () => {
                this.switch('help');
            })
            .else(() => {
                this.router.update('intro');
            })
            .match();
    }

    async switchForm() {
        const valid = await this.views.eligibility.isValid();
        if (valid) {
            this.switch('form');
        } else {
            this.router.update('eligibility');
        }
    }

    switch(view) {
        Object.keys(this.views).forEach((v) => (v === view ? this.views?.[v].show() : this.views?.[v].hide()));
        scrollToElement();
    }

    onSuccess() {
        this.router.update('result');
        this.views.result.render(this.order);
        this.AnalyticsHelper.template(this.form.button, { model: this.order?.summary?.ids?.modelCode });
        this.AnalyticsHelper.push(this.form.button);
    }

    onError() {
        this.form.showError();
        this.preventSubmitInput.value = 'true';
    }

    onSubmit() {
        this.preventSubmitInput.value = 'false';
    }

    onUpdate(field, valid) {

    }

    onInvalid() {
        this.views.form.showErrorSections();
    }

    showLoader() {
        this.loader.classList.remove('hide');
    }

    hideLoader() {
        this.loader.classList.add('hide');
    }

    redirect(url) {
        window.location.href = url ?? '/';
    }

    parse(json) {
        try {
            return json ? JSON.parse(json) : null;
        } catch (err) {
            return null;
        }
    }
}
